import React from 'react';

export function ProjectPersonnelContractors({ contractors }: { contractors: any[] }) {
  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <div className="flex items-center justify-between border-b border-slate-50 pb-2">
        <h3 className="text-sm font-normal text-slate-900">Nhà thầu phụ</h3>
        <button className="text-xs font-normal text-emerald-600 hover:underline">Tất cả</button>
      </div>

      <div className="space-y-3">
        {contractors.map((c) => (
          <div key={c.id} className="flex items-center justify-between group cursor-pointer">
             <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-md bg-slate-50 flex items-center justify-center group-hover:bg-emerald-50 transition-colors">
                   <i className="ri-building-line text-slate-400 group-hover:text-emerald-500" />
                </div>
                <div className="flex justify-between items-start mb-1.5">
                <span className="text-xs font-normal text-slate-700 truncate flex-1">{c.name}</span>
                <span className="text-xs font-normal text-slate-900 ml-2">{c.count} người</span>
             </div>
          </div>
          </div>
        ))}
      </div>
    </div>
  );
}
